const INPUT_FILE_ACCEPT: Record<SmtTask.FilesAcceptSet, ReadonlyArray<string>> = {
    archive:        ['zip', '7z'],
    image:          ['heic', 'heif', 'png', 'jpeg', 'jpg', 'tiff'],
    svg:            ['svg'],
    fileWithText:   ['docx', 'odt', 'pdf'],
    documentPhoto:  ['png', 'jpeg', 'jpg', 'tiff', 'pdf'],
    presentation:   ['pptx', 'odp', 'key', 'pdf'],
    pdf:            ['pdf'],
    spreadsheet:    ['xlsx', 'ods'],
    latex:          ['tex', 'latex'],
    arduino:        ['ino', 'py'],
    json:           ['json'],
    noAccept:       []
} as const;

const getInputFileAccept = (acceptSet: SmtTask.FilesAcceptSet) =>
    acceptSet && acceptSet in INPUT_FILE_ACCEPT
        ? INPUT_FILE_ACCEPT[acceptSet].map(ext => `.${ext}`).join(', ')
        : void(0)
;

export {
    getInputFileAccept
}
